var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceOutsideIconLonghaul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M10.496 16.498v.442s-.032-.176 0-.442M9.927 16.762c.03.255 0 .422 0 .422v-.422z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    d: "M9.927 16.762c.03.255 0 .422 0 .422v-.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M10.735 16.762v.422s-.03-.167 0-.422"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    d: "M10.735 16.762v.422s-.03-.167 0-.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M10.735 17.184s-.03-.167 0-.422v.422zm-.808 0v-.422c.03.255 0 .422 0 .422z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    d: "M10.735 17.184s-.03-.167 0-.422v.422zm-.808 0v-.422c.03.255 0 .422 0 .422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M8.275 14.902a5.634 5.634 0 0 1-3.568-5.235.41.41 0 1 1 .818 0 4.815 4.815 0 0 0 4.809 4.808 4.815 4.815 0 0 0 4.808-4.808 4.811 4.811 0 0 0-4.808-4.809.39.39 0 0 1-.29-.122.391.391 0 0 1-.122-.29.41.41 0 0 1 .412-.406c3.1 0 5.626 2.521 5.626 5.627 0 2.374-1.479 4.406-3.563 5.235h-.005c-.046.015-.086.03-.127.051-1.144.437-1.449 1.23-1.52 1.743v5.429a.412.412 0 0 1-.823 0v-5.393c-.066-.513-.361-1.332-1.52-1.779l-.127-.051z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    d: "M8.275 14.902a5.634 5.634 0 0 1-3.568-5.235.41.41 0 1 1 .818 0 4.815 4.815 0 0 0 4.809 4.808 4.815 4.815 0 0 0 4.808-4.808 4.811 4.811 0 0 0-4.808-4.809.39.39 0 0 1-.29-.122.391.391 0 0 1-.122-.29.41.41 0 0 1 .412-.406c3.1 0 5.626 2.521 5.626 5.627 0 2.374-1.479 4.406-3.563 5.235h-.005c-.046.015-.086.03-.127.051-1.144.437-1.449 1.23-1.52 1.743v5.429a.412.412 0 0 1-.823 0v-5.393c-.066-.513-.361-1.332-1.52-1.779l-.127-.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M9.927 17.184v-.422c.03.255 0 .422 0 .422"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    d: "M9.927 17.184v-.422c.03.255 0 .422 0 .422z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.362 4.732H1.319a.8.8 0 0 1-.797-.798V3.81a.8.8 0 0 1 .797-.798h6.043a.8.8 0 0 1 .797.798v.124a.8.8 0 0 1-.797.798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48 6.893V.851a.8.8 0 0 1 .798-.798h.125A.8.8 0 0 1 5.2.851v6.042a.8.8 0 0 1-.797.798h-.125a.8.8 0 0 1-.797-.798"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M11.823 9.666a1.491 1.491 0 1 1-2.983 0 1.491 1.491 0 0 1 2.983 0M9.14 14.794l1.292 1.876 1.5-1.876z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceOutsideIconLonghaul);
export default __webpack_public_path__ + "static/media/price-outside-icon-longhaul.8495e35c94965881e4fe75b5c2fa0839.svg";
export { ForwardRef as ReactComponent };